/* eslint-disable */
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper'; 
import AOS from 'aos';
import 'simplelightbox/dist/simple-lightbox.jquery'


export default {
    init() {
      
      AOS.init();

      $('.image-banner__wrap a').simpleLightbox({
        
      });

    const swiperContainerProjecten = document.getElementById('swiper-container-projecten');

    if (swiperContainerProjecten) {

      Swiper.use([Navigation]);

      const swiperContainerProjectenSwiper = new Swiper('.swiper-container-projecten', {
        // Optional parameters
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
          nextEl: '.projecten-slider__nav--right',
          prevEl: '.projecten-slider__nav--left',
        },
        breakpoints: {
          500: {
            slidesPerView: 2,
            spaceBetweenSlides: 15,
          },
          850: {
            slidesPerView: 3,
            spaceBetweenSlides: 15,
          },
        },
      })
      swiperContainerProjectenSwiper.init();
    }

    //dealers

    $(".dealers__info").first().addClass("dealers__info--active");
    $(".dealers__people-single").first().addClass("dealers__people-single--active");

    $(".dealers__people-single").on("click", function()  {
      var index = $(this).index();
      $(".dealers__people-single").removeClass("dealers__people-single--active");
      $(this).addClass("dealers__people-single--active");
      $(".dealers__info").removeClass("dealers__info--active");
      $(".dealers__info:eq(" + index + ")").addClass("dealers__info--active");
    })

    $(".image-banner__wrap").each(function(i, obj) {
      var child_amount = $(obj).children().length;
      var var_width = 100 / child_amount;
      $(obj).children().width( var_width + '%' );
    });

    const swiperContainerSmallImageslider = document.getElementById('swiper-container-smallimageslider');

    if (swiperContainerSmallImageslider) {

      Swiper.use([Navigation, Pagination]);

      const swiperContainerSmallImagesliderSwiper = new Swiper('.swiper-container-smallimageslider', {
        // Optional parameters
        slidesPerView: 3,
        spaceBetween: 8,
        navigation: {
          nextEl: '.smallimageslider-slider__nav--right',
          prevEl: '.smallimageslider-slider__nav--left',
        },
        pagination: {
          el: '.swiper-pagination-smallimageslider',
          type: 'fraction',
        },
        breakpoints: {
          319: {
            slidesPerView: 1.5,
            spaceBetweenSlides: 8,
          },
          450: {
            slidesPerView: 2,
            spaceBetweenSlides: 8,
          },
          650: {
            slidesPerView: 3,
            spaceBetweenSlides: 8,
          },
        },
      })
      swiperContainerSmallImagesliderSwiper.init();
    }


    const swiperContainer360Slider = document.getElementById('swiper-container-360slider');

    if (swiperContainer360Slider) {

      const swiperContainer360SliderSwiper = new Swiper('.swiper-container-360slider', {
        // Optional parameters
        spaceBetween: 10,
        slidesPerView: "auto",

      })
      swiperContainer360SliderSwiper.init();
    }
        
    new Swiper('#heroLogoCarousel', {
        // Optional parameters
        slidesPerView: 3,
        spaceBetween: 15,
        breakpoints: {
          520: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          740: {
            slidesPerView: 7,
            spaceBetween: 30,
          },
        },
    })    
    


    // Retrieve the "show_first_answer" value from the data attribute
    var showFirstAnswer = $("#faq_container").data("show-first-answer");

    // Check if "showFirstAnswer" is true
    if (showFirstAnswer === true) {
        // Enable the first line (show the first answer)
        $('.faq__question-title').first().next().show();
    }

    // Add the click event for all question titles
    $(".faq__question-title").on('click', function() {
        $(this).next().slideToggle('fast');
    });
  
        
        // Scroll ID(anchor) to animation
    $('a[href^="#"]').on('click', function (event) {
        var target = $(this.getAttribute('href'));
        var textTar = $(this).text().toLowerCase();
        if (target.length) {
          event.preventDefault();
          $('html, body').stop().animate(
            {
              scrollTop: target.offset().top - 100,
            },
            1000
          );
        } else {
          location.href = '/#' + textTar;
        }
      });

      // 360 popup, het iframe url from data attr so that iframe only loaded on click
        
        $('.360-slide').on('click', (e) => {
            let iframeUrl = e.target.dataset.iframe;

            console.log(iframeUrl);

            $('.bg__overlay').fadeIn();

            $('#iframeTarget').fadeIn();
            $('#iframeTarget > iframe').attr('src', iframeUrl);
        })

        // close it

        $('.bg__overlay').on('click', () => {
            $('.bg__overlay').fadeOut();
            $('#iframeTarget').fadeOut();
            $('#iframeTarget > iframe').attr('src', '');
        })

        $('.close').on('click', () => {
            $('.bg__overlay').fadeOut();
            $('#iframeTarget').fadeOut();
            $('#iframeTarget > iframe').attr('src', '');
        })

        //mobile header

        $('.mobile-hamburger-icon').on('click', function() {
          $(".bottom-nav").toggleClass('bottom-nav--active');
          $(this).toggleClass('mobile-hamburger-active');
          // $('.site-header-secondary').toggleClass('site-header-secondary--active')
          // setTimeout(function() {
          //   $(".bottom-nav").toggleClass('bottom-nav--active');
          // }, 550);
        })

        const swiperIconrow = document.getElementById('swiper-container-iconrow');

        if (swiperIconrow) {
          Swiper.use([Autoplay]);
    
          const swiperIconrowSwiper = new Swiper('.swiper-container-iconrow', {
            // Optional parameters
            spaceBetween: 10,
            slidesPerView: "auto",
            loop: 'true',
    
          })
          swiperIconrowSwiper.init();
        }

        $(window).on('scroll', function() {
          if ($(document).scrollTop() > 44) {
            $('.site-header__inner').addClass('stick');
          }
          else {
            $('.site-header__inner').removeClass('stick');
          }
        });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js